import { useQuery } from 'react-query';
import { getKsaCities } from '~/api/cities';
import { useSetLanguage } from '~/hooks/i18nHooks';

export const useKsaCities = () => {
  const { language } = useSetLanguage();

  return useQuery(['ksaCities', language], getKsaCities, { staleTime: Infinity });
};
